import React from 'react';
import css from '../../styles.module.css';

export default function SubSection({ name, content }) {
    return (
        <div className={css['summary-header-subtitle']}>
            <span>{name}</span>
            {content}
        </div>
    );
}
